import { createAction } from '@reduxjs/toolkit';
import {
  IContactPreferenceUserFetchSuccess,
  IContactPreferenceAdminFetchSuccess,
  IContactPreferenceUserSave,
  IContactPreferenceAdminSave,
  IContactPreferenceAdminError
} from './models';

// User Fetch
export const actionContactPreferenceUserFetch = createAction('contactPreferenceUser/fetch');
export const actionContactPreferenceUserFetchSuccess = createAction(
  'contactPreferenceUser/fetch/success',
  (payload?: IContactPreferenceUserFetchSuccess) => ({ payload })
);
export const actionContactPreferenceUserFetchError = createAction(
  'contactPreferenceUser/fetch/error',
  (error: any) => ({
    payload: undefined,
    error
  })
);

// User Save
export const actionContactPreferenceUserSave = createAction(
  'contactPreferenceUser/save',
  (payload: IContactPreferenceUserSave) => ({ payload })
);
export const actionContactPreferenceUserSaveSuccess = createAction('contactPreferenceUser/save/success');
export const actionContactPreferenceUserSaveError = createAction('contactPreferenceUser/save/error', (error: any) => ({
  payload: undefined,
  error
}));

// Admin Fetch
export const actionContactPreferenceAdminFetch = createAction('contactPreferenceAdmin/fetch');
export const actionContactPreferenceAdminFetchSuccess = createAction(
  'contactPreferenceAdmin/fetch/success',
  (payload?: IContactPreferenceAdminFetchSuccess) => ({ payload })
);
export const actionContactPreferenceAdminFetchError = createAction(
  'contactPreferenceAdmin/fetch/error',
  (error: any) => ({ payload: undefined, error })
);

// Admin Save
export const actionContactPreferenceAdminSave = createAction(
  'contactPreferenceAdmin/save',
  (payload: IContactPreferenceAdminSave) => ({ payload })
);
export const actionContactPreferenceAdminSaveSuccess = createAction('contactPreferenceAdmin/save/success');
export const actionContactPreferenceAdminSaveError = createAction(
  'contactPreferenceAdmin/save/error',
  ({ error, ...payload }: IContactPreferenceAdminError) => ({
    payload,
    error
  })
);
